import  { useState } from 'react';
import './AuthPopup.css';

const AuthPopup = ({ animationClass, setUsernamePopup, onRegister, onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    name: '',
  });

  const handleClose = (e) => {
    e.preventDefault();
    setUsernamePopup(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLogin) {
      await onLogin(formData);
    } else {
      await onRegister(formData);
    }
  };

  const toggleForm = () => setIsLogin((prev) => !prev);

  return (
    <div className="auth-popup">
      <form
        className={`auth-form animate__animated ${animationClass}`}
        onSubmit={handleSubmit}
      >
        <h2>{isLogin ? 'Login' : 'Register'}</h2>

        {!isLogin && (
          <>
            <input
              type="text"
               autoComplete='off'
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
             autoComplete='off'
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </>
        )}

        <input
          type="text"
          name="username"
          autoComplete='off'
          placeholder="Username"
          value={formData.username}
          onChange={(e) => setFormData({ ...formData, username: e.target.value })}
        />
        <input
          type="password"
          name="password"
           autoComplete='off'
          placeholder="Password"
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        />

        <div className="auth-buttons">
          <button type="button" className="switch" onClick={toggleForm}>
            {isLogin ? "Don't have an account?" : 'Already have an account?'}
          </button>
          <button type="submit" className="submit">
            {isLogin ? 'Login' : 'Register'}
          </button>
          <button type="button" className="close" onClick={handleClose}>
            Close
          </button>
        </div>
      </form>
    </div>
  );
};

export default AuthPopup;
